export default __webpack_public_path__ + "static/media/signal_best.adbc3543.svg";